module.exports = __webpack_public_path__ + "img/current-location.694f10f1.gif";